/**
 * Sort an array alphabetically by an object key
 */
export const sortAlphabeticallyByKey = (array, key) => {
    return array.sort((a, b) => a[key].localeCompare(b[key], undefined, { sensitivity: 'base' }));
};
/**
 * Detect if an array is equal
 *
 * Optionally specifiy whether you want to inspect order of elements too
 */
export const isEqual = (firstArray, secondArray, inspectOrder = true) => {
    if (firstArray.length !== secondArray.length) {
        return false;
    }
    if (inspectOrder) {
        return firstArray.every((item, index) => Object.is(item, secondArray[index]));
    }
    const remainingItems = [...secondArray];
    return firstArray.every((item) => {
        const matchingIndex = remainingItems.findIndex((candidate) => Object.is(candidate, item));
        if (matchingIndex === -1) {
            return false;
        }
        remainingItems.splice(matchingIndex, 1);
        return true;
    });
};
